import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class ViewAssignedObjectionSuggestionListService {

  constructor(public httpClient: HttpClient) { }




  async replyObjectionSuggestion(data: any) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.objectionReplyFromInternalUser, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async loadStatus() {
    const url = "loadStatus";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadOSStatus, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async downloadAttachment(ghDocument) {
    const data = {
      'documentPath': ghDocument
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.downloadFileForGrievance, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }



  async loadObjectionSuggestionHistoryById(id){
    const data = {'osId': id};
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadOSHistory,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

}

